import { FC } from 'react';

import {
  BonusIcon,
  ClockIcon,
  ICommonIconProps,
  PrinterIcon,
  ShopIcon,
  TIconName,
  WalletIcon,
} from '@smartshell/ui-kit';

import type { IPaymentHistoryItem } from 'types';
import { EPaymentItemType } from 'types';

import { ICategoryConfig } from './interfaces';

export const formatSum = (sum: number): string =>
  sum.toLocaleString(undefined, { maximumFractionDigits: 2 });

export const getIconName = (
  type: IPaymentHistoryItem['items'][0]['type']
): TIconName => {
  switch (type) {
    case EPaymentItemType.DEPOSIT:
      return 'WalletIcon';
    case EPaymentItemType.TARIFF:
      return 'ClockIcon';
    case EPaymentItemType.GOOD:
      return 'ShopIcon';
    case EPaymentItemType.SERVICE:
      return 'PrinterIcon';
    case EPaymentItemType.BONUS:
      return 'BonusIcon';
  }
};

export const getIcon = (
  type: IPaymentHistoryItem['items'][0]['type']
): FC<ICommonIconProps> => {
  switch (type) {
    case EPaymentItemType.DEPOSIT:
      return WalletIcon;
    case EPaymentItemType.TARIFF:
      return ClockIcon;
    case EPaymentItemType.GOOD:
      return ShopIcon;
    case EPaymentItemType.SERVICE:
      return PrinterIcon;
    case EPaymentItemType.BONUS:
      return BonusIcon;
  }
};

export const getCategoryConfig = (
  items: IPaymentHistoryItem['items']
): ICategoryConfig | null => {
  const type = items[0]?.type;

  if (!type) return null;

  for (const currentItem of items) {
    if (type !== currentItem.type)
      return {
        locale: 'payments.category.multi',
        multi: true,
        iconName: 'AppsIcon',
      };
  }

  if (type === 'TARIFF')
    return { locale: 'payments.category.tariffs', iconName: getIconName(type) };
  if (type === 'GOOD')
    return { locale: 'payments.category.goods', iconName: getIconName(type) };
  if (type === 'SERVICE')
    return {
      locale: 'payments.category.services',
      iconName: getIconName(type),
    };

  return null;
};
